import React, { useEffect, useState } from "react";

const testimonials = [
  {
    image: "images/resources/testi-1-2.jpg",
    name: "Mr. Rajesh Sharma",
    text: "Om Sai Cab Service provided an excellent travel experience with professional drivers and clean vehicles. Highly reliable and comfortable service.",
  },

  {
    image: "images/resources/testi-1-5.jpg",
    name: "Mr. Amit Patel",
    text: "I booked Om Sai Cab Service for an outstation trip and the experience was amazing. Safe driving and great customer support.",
  },
    {
    image: "images/resources/testi-1-1.jpg",
    name: "Miss. Priya Verma",
    text: "Very punctual and affordable cab service. The booking process was smooth and the driver was polite throughout the journey.",
  },
  {
    image: "images/resources/testi-1-4.jpg",
    name: "Miss. Neha Gupta",
    text: "Clean cars, professional staff, and on-time pickup made my trip stress-free. I would definitely recommend Om Sai Cab Service.",
  },
    {
    image: "images/resources/testi-1-3.jpg",
    name: "Miss. Kavita Mishra",
    text: "Excellent service with comfortable rides and friendly drivers. Om Sai Cab Service made our family trip enjoyable and safe.",
  },
  {
    image: "images/resources/testi-1-6.jpg",
    name: "Mr. Sandeep Yadav",
    text: "The driver was very courteous and the fare was reasonable. One of the best cab services I have used recently.",
  },

];

const TestimonialsStyleOne = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto slider
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  return (
    <section className="testimonials-style-one">
      <div className="container">
        {/* Section Title */}
        <div className="block-title text-center">
          <div className="dot-line"></div>
          <p className="light">What our clients say</p>
          <h2 className="light">Testimonials</h2>
        </div>

        {/* Pager Images */}
        <div className="testimonials-one-pager">
          {testimonials.map((item, index) => (
            <button
              key={index}
              className={`pager-item ${
                currentSlide === index ? "active" : ""
              }`}
              onClick={() => setCurrentSlide(index)}
              style={{
                border: "none",
                background: "transparent",
                padding: "0",
                margin: "0 5px",
                cursor: "pointer",
              }}
            >
              {/* <img
              className="d-none d-md-block"
                src={item.image || "images/default-user.jpg"}
                alt={item.name}
              /> */}
            </button>
          ))}
        </div>

        {/* Testimonial Content */}
        <div className="single-testimonial-one text-center">
          <p>{testimonials[currentSlide].text}</p>
          <h3>{testimonials[currentSlide].name}</h3>
        </div>
      </div>

      {/* Slider Buttons */}
      <div className="testimonials-one-slider-btn d-none d-md-block">
        <span className="carousel-btn left-btn" onClick={prevSlide}>
          <i className="fa fa-chevron-left"></i>
        </span>

        <span className="carousel-btn right-btn d-none d-md-block" onClick={nextSlide}>
          <i className="fa fa-chevron-right"></i>
        </span>
      </div>
    </section>
  );
};

export default TestimonialsStyleOne;